import styled from 'styled-components';
import { SIZE, LAYERS } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { Label } from 'common/baseComponents';

export const MainContainer = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    border-radius: ${SIZE.HALF}px;
    // width: ${SIZE.THIRTY_TWO}px;
    height: ${SIZE.FOUR}px;
`;

export interface LabelContainerProps {
    readonly?: boolean
}
export const LabelContainer = styled.div`
    display:flex;
    flex:1;
    background-color: #FFF;
    border: 1px solid transparent;
    height: ${SIZE.SIX}px;
    border-radius: ${SIZE.HALF}px;
    text-align: center;

    &:hover {
        cursor: ${(props: LabelContainerProps) => props.readonly ? 'not-allowed' : 'pointer'};
    }
`
export interface InputContainerProps {
    height?: string
}

export const InputContainer = styled(LabelContainer)`
    background: white;
    height: ${(props: InputContainerProps) => props.height ? props.height : `${SIZE.FOUR}px`};
    flex:unset;
    align-items: center;
    padding: 0 0 0 0;
    border-radius: ${SIZE.HALF}px;
`
export const InputIcon = styled.span`
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 14px;
    position: relative;
    margin-right: ${SIZE.TWO}px;
`

export const SuggestLabel = styled(Label)`
    display:flex;
    align-items: center;
    position: relative;
    height: inherit;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    letter-spacing: 1.3px;
    flex:1;
    justify-content: flex-start;
    padding: 0 0 ${SIZE.THREE}px ${SIZE.THREE}px;
    color: #373f53;
    border-radius: ${SIZE.HALF}px;
    
`

export const InputSuggestable = styled.input`
    display:flex;
    height: inherit;
    outline: none;
    padding: none;
    border: none;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 1.3px;
    flex:1;
    color: #373f53;
    background: transparent;
    &:hover {
        cursor:pointer;
    };
    &:focus {
        cursor: text;
    }
`

export const DrawerContainer = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    right:0px;

    z-index: ${LAYERS.LAYER_5};
    display: flex;
    flex-flow: column;
    max-height: ${SIZE.FORTY}px;
    background: transparent;

    border-radius: ${SIZE.HALF}px;
    margin-bottom: ${SIZE.ONE}px;
`

export const DrawerOptionsContainer = styled.div`
    position: relative;
    top: ${SIZE.HALF}px;
    max-height: ${SIZE.THIRTY_FIVE}px;

    border-radius: ${SIZE.HALF}px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);

    background: white;
    display:flex;
    flex:1;
    overflow: auto;
`

export const DrawerList = styled.ul`
    
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
    flex:1;
    overflow: auto;
`
export interface DrawerListItemProps {
    highlighted: boolean
}

export const DrawerListItem = styled.li`
    height: ${SIZE.FOUR}px;
    display:flex;
    padding:${SIZE.ONE}px;
    align-items: center;
    &:hover {
        cursor: pointer;
    };
    background: ${(props: DrawerListItemProps) => props.highlighted ? '#DADADA' : 'none'};
`
export const DrawerItemLabel = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    overflow:hidden;
    white-space:nowrap;
    color: #373f53;
    margin: 0 ${SIZE.ONE}px 0 ${SIZE.ONE}px;
`

export const DrawerEmptyState = styled(Label)`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #373f53;
    padding: ${SIZE.TWO}px;
    margin: 0 ${SIZE.ONE}px 0 ${SIZE.ONE}px;
    justify-content: center;
    align-items: center;
`

export const LoadMoreTarget = styled.div`
    display:flex;
    height: ${SIZE.FIVE}px;
    align-items:center;
    justify-content: center;
`